import { useFormContext } from 'react-hook-form';

import { useIsAudience, useIsExisting, useSaveStoreSelector } from 'pages/audience/shared/save/hooks';
import { SaveForm } from 'types/pages/audience-builder/shared/save';

export const useClientConfiguration = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SaveForm>();
  const isAudience = useIsAudience();
  const isExisting = useIsExisting();

  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  return { control, errors, readOnly: (isExisting || saveTo) && !isAudience };
};
